<template>
  <Card class="menu-card">
    <el-menu slot="title" :default-active="activeIndex" mode="horizontal" @select="handleSelect">
      <el-menu-item index="3">收费明细统计</el-menu-item>
      <el-menu-item index="2">收费日报统计</el-menu-item>
      <el-menu-item index="1">收费总览统计</el-menu-item>
    </el-menu>
    <div slot="content">
      <StaffChargeDetails v-if="menuIndex == 3" />
      <StaffChargeDaily v-if="menuIndex == 2" />
      <StaffChargeOverview v-if="menuIndex == 1" />
    </div>
  </Card>
</template>

<script lang="js">
import StaffChargeOverview from "./StaffChargeOverview.vue"; // 员工收费总览
import StaffChargeDaily from "./StaffChargeDaily.vue"; // 员工收费日报
import StaffChargeDetails from "./StaffChargeDetails.vue"; // 员工收费详情
export default {
  name: "StaffCharge",
  components: { StaffChargeDaily, StaffChargeDetails, StaffChargeOverview },
  data() {
    return {
      activeIndex: "1", // 默认激活菜单
      menuIndex: "1", // 菜单索引
    }
  },
  created() {
    let index = this.$session.get('staffChargeIndex')
    if (index) this.activeIndex = this.menuIndex = index;
  },
  methods:{
    // 切换当前显示组件
    handleSelect(key) {
      this.menuIndex = key;
      this.$session.set('staffChargeIndex', key);
    }
  }
};
</script>